/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/calendar'
export default icon
